import { ExecutionQueue } from "gather-video-common/dist/src/public/ExecutionQueue";
import { VideoSpatialLayer, } from "gather-video-common/dist/src/public/types";
import { gatherVideoClientDataSource, metricsManager as globalsMetricsManager, } from "../../Globals";
import { getProducerConfig, getScreenShareMaxBitrate } from "../../config";
import { debugLogMajorEvent } from "../../DebugLogger";
import { setProducerEncodingsByQuality } from "./mediasoupUtils";
import { SignaledDevice } from "./SignaledDevice";
import { SignaledTransport } from "./SignaledTransport";
import { Signaling } from "./Signaling";
import { calculateBitrate, checkVideoTrackHasOutputAfterFiveSec, ConsumerKindToMediaKind, getBitRateByLayer, getPixelRateByLayer, getSpatialTemporalLayerByVideoStat, ignoreExecutionQueueExceptions, nextLayerUp, prefixKeys, shouldUseHighQualityScreenshare, summarizeMediaStreamTrack, } from "../../utils";
import { isEqual, noop, sortBy } from "lodash";
import { Logger } from "../../Logger";
import { ConsumerState, createConsumerInfo, MigrationState, } from "../../ConsumerInfo";
import { partial } from "ramda";
import { tracker } from "../../tracker/Tracker";
import { metricsManager } from "../../metrics/MetricsManager";
import { LOG_TO_NEWRELIC_TIMEOUTS_S, measureAvLoadtime, VideoPerformanceStages, videoPerformanceTracker, } from "../../videoPerformance";
import { debounceAsync, deferredPromise } from "gather-common/dist/src/public/promises";
import { buildErrorContext, ErrorContext, guaranteedError, } from "gather-common/dist/src/public/utils";
import { ConnectionAttemptCounter, getReloadDelayMs } from "./reconnectUtils";
import { GatedFeatName } from "gather-client-common/dist/src/public/gatekeeping/FEATURES";
import { VIDEO_SYSTEM_AUTOMATED_REPORT } from "gather-common/dist/src/public/av";
import { DEFAULT_VIDEO_CAPTURE_FPS, DEFAULT_VIDEO_CAPTURE_HEIGHT, DEFAULT_VIDEO_CAPTURE_WIDTH, } from "gather-video-common/dist/src/public/settings";
import { kindLongFormat, statsArrayToObj } from "gather-video-common/dist/src/public/serverStats";
import { GVCEventEmitter, GVCInternalEvent } from "../../EventEmitter/GVCEventEmitter";
import { WebRTCTransportErrorCode, } from "../../EventEmitter/WebRTCTransportEvents";
import { WebSocketConnectionState, WebSocketDisconnectReason, } from "../../EventEmitter/WebSocketEvents";
import { TRANSPORT_DISCONNECTED_GRACE_PERIOD_MS } from "./TransportConnectionStateHelper";
import { IceRestartReason } from "./IceRestartReason";
const STATS_RAMP_UP_TIME = 5000;
const BANDWIDTH_FULFILLMENT_MONITOR_INTERVAL = 5000;
const DEFAULT_TEMPORAL_LAYER = 1;
const MAX_CONSUMERS_BEFORE_CLOSE = 150;
export class SFUClient {
    externalEventEmitter;
    internalEventEmitter = new GVCEventEmitter();
    cleanupFns = [];
    serverURL = "";
    id = "";
    room = "";
    turnProvider;
    iceTransportRequestOptions;
    destroyed = false;
    destroyedPromise = deferredPromise();
    signaling;
    subscribed = {};
    actuallySubscribed = {};
    allowed = new Set();
    tracks = new Map();
    paused = new Map();
    maxProducerSpatialLayer = VideoSpatialLayer.LowQuality;
    defaultMaxConsumerSpatialLayer = VideoSpatialLayer.LowQuality;
    _lastMaxConsumerLayers = {};
    device;
    sendTransport;
    recvTransport;
    producers = new Map();
    consumers = new Map();
    recyclableConsumers = new Map();
    pausedConsumers = new Set();
    info = {};
    rtcStatsManager;
    consumeQ = new ExecutionQueue();
    produceQ = new ExecutionQueue();
    signalingReconnectTimer;
    finishedInitialStart = false;
    initialCallbacksPopulated = false;
    continuousConnectionFailureCount = 0;
    bandwidthMonitorInterval;
    prevConsumerStats = new Map();
    prevScreenshareConsumerStats = new Map();
    videoTrackCheckOutputTimeouts = new Map();
    onInboundBandwidthFulfillment(_bandwidthFulfillment) { }
    shouldCancelInitialStart = () => false;
    resolveInitialStartPromise = () => { };
    rejectInitialStartPromise = () => { };
    initialStartPromise = new Promise((resolve, reject) => {
        this.resolveInitialStartPromise = resolve;
        this.rejectInitialStartPromise = reject;
    });
    onInfo(_info) { }
    onDisableVideo() { }
    onOverAllow(_over) { }
    sendDebugReport(_message, _reason, _remotePlayers) { }
    connectionAttemptCounter;
    reloadingLock = false;
    reloading = false;
    onReloadChange(_reload) { }
    onProduceClose(_kind) { }
    onSelfProduceScore(_data) { }
    onSFUSignalingConnect() { }
    onMoveOff() {
        return new Promise((resolve) => resolve({ succeed: false, newSfu: "" }));
    }
    onDeviceConnectError() { }
    onWebSocketFailedToConnect = (_additionalContext) => { };
    onProducerSfuConnected(_sfuAddr) { }
    onSFUProducersStats(_stats) { }
    onSFUConsumersStats(_srcId, _stats) { }
    getMaxConsumerSpatialLayer = (_id, _tag) => this.defaultMaxConsumerSpatialLayer;
    getLocalVideoCaptureResolution = () => ({
        width: DEFAULT_VIDEO_CAPTURE_WIDTH,
        height: DEFAULT_VIDEO_CAPTURE_HEIGHT,
    });
    screenshareBandwidthMonitor = (consumer) => {
        if (!consumer || !consumer.rtpReceiver || consumer.paused)
            return;
        const stats = this.rtcStatsManager.getCachedRecvTransceiverStats(this.serverURL, consumer.rtpReceiver);
        const stat = stats[0];
        if (stat) {
            const previousStat = this.prevScreenshareConsumerStats.get(consumer.id);
            this.prevScreenshareConsumerStats.set(consumer.id, stat);
            if (previousStat && stat.timestamp > previousStat.timestamp) {
                const timeDeltaInSec = (stat.timestamp - previousStat.timestamp) / 1000;
                const receivedBitrate = Math.round(calculateBitrate(stat.bytesReceived, previousStat.bytesReceived, timeDeltaInSec));
                return {
                    targetBitrate: getScreenShareMaxBitrate((stat.framesPerSecond ?? 0) > 6),
                    receivedBitrate,
                };
            }
        }
        return undefined;
    };
    inboundBandwidthMonitor = () => {
        if (this.room === "" || this.destroyed)
            return;
        const players = {};
        let expectedPixelRateSum = 0;
        let receivedPixelRateSum = 0;
        let numConsumers = 0;
        const screenshareBitrates = [];
        this.consumers.forEach((consumers, playerId) => {
            const screenConsumer = consumers.get("screen");
            const screenshareBitrate = this.screenshareBandwidthMonitor(screenConsumer);
            if (screenshareBitrate) {
                screenshareBitrates.push(screenshareBitrate);
            }
            const videoConsumer = consumers.get("video");
            if (!videoConsumer || !videoConsumer.rtpReceiver || videoConsumer.paused)
                return;
            const lastLayerRequest = this._lastMaxConsumerLayers[videoConsumer.id];
            if (!lastLayerRequest)
                return;
            const stats = this.rtcStatsManager.getCachedRecvTransceiverStats(this.serverURL, videoConsumer.rtpReceiver);
            const stat = stats[0];
            if (!stat)
                return;
            const previousStat = this.prevConsumerStats.get(videoConsumer.id);
            this.prevConsumerStats.set(videoConsumer.id, stat);
            if (!previousStat || stat.timestamp <= previousStat.timestamp)
                return;
            if (stat.timestamp - lastLayerRequest.timestamp < STATS_RAMP_UP_TIME)
                return;
            if (stat.frameWidth !== previousStat.frameWidth ||
                stat.frameHeight !== previousStat.frameHeight) {
                return;
            }
            const timeDeltaInSec = (stat.timestamp - previousStat.timestamp) / 1000;
            const framesReceivedDelta = (stat.framesReceived ?? 0) - (previousStat.framesReceived ?? 0);
            const recvFrameRate = Math.min(Math.round(framesReceivedDelta / timeDeltaInSec), DEFAULT_VIDEO_CAPTURE_FPS);
            const expectedPixelRate = getPixelRateByLayer(lastLayerRequest.spatialLayer, lastLayerRequest.temporalLayer);
            const receivedPixelRate = (stat.frameWidth ?? 0) * (stat.frameHeight ?? 0) * recvFrameRate;
            const sanitizedWidth = Math.max(stat.frameWidth ?? 0, stat.frameHeight ?? 0);
            const { spatialLayer, temporalLayer } = getSpatialTemporalLayerByVideoStat(sanitizedWidth, recvFrameRate);
            const receivingLessPixelRate = receivedPixelRate < expectedPixelRate;
            const receivingRequestedLayer = spatialLayer === lastLayerRequest.spatialLayer &&
                temporalLayer === lastLayerRequest.temporalLayer;
            if (receivingLessPixelRate && !receivingRequestedLayer) {
                const { spatialLayer: nextSpatialLayer, temporalLayer: nextTemporalLayer } = nextLayerUp(spatialLayer, temporalLayer);
                const expectedBitrate = getBitRateByLayer(nextSpatialLayer, nextTemporalLayer);
                const receivedBitrate = Math.round(calculateBitrate(stat.bytesReceived, previousStat.bytesReceived, timeDeltaInSec));
                const additionalBitrateNeeded = expectedBitrate - receivedBitrate;
                players[playerId] = { expectedPixelRate, receivedPixelRate, additionalBitrateNeeded };
                Logger.info(`[BitM] ${playerId} receiving L${spatialLayer}T${temporalLayer}@${recvFrameRate} ${receivedBitrate}, next layer requires ${expectedBitrate}`);
            }
            expectedPixelRateSum += expectedPixelRate;
            receivedPixelRateSum += receivedPixelRate;
            numConsumers++;
        });
        if (numConsumers > 0) {
            this.onInboundBandwidthFulfillment({
                consumers: numConsumers,
                totalConsumers: this.consumers.size,
                expectedPixelRate: expectedPixelRateSum,
                receivedPixelRate: receivedPixelRateSum,
                players,
                screenshareBitrates,
            });
        }
    };
    onWebRTCTransportError = (errorCode, context) => {
        const { id, connectionState, error } = context;
        const direction = id === this.sendTransport?.id ? "send" : "recv";
        const retryWithICERestart = () => {
            if (this.sendTransport && id === this.sendTransport.id) {
                this.sendTransport.restartIce(IceRestartReason.FailedState).catch((error) => {
                    setTimeout(() => {
                        this.internalEventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.ICERestartFailure, {
                            sfuAddr: this.serverURL,
                            id,
                            error,
                        });
                    }, 0);
                });
            }
            else if (this.recvTransport && id === this.recvTransport.id) {
                this.recvTransport.restartIce(IceRestartReason.FailedState).catch((error) => {
                    setTimeout(() => {
                        this.internalEventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.ICERestartFailure, {
                            sfuAddr: this.serverURL,
                            id,
                            error,
                        });
                    }, 0);
                });
            }
            else {
                Logger.error("Attempt to restart ICE, but either the id mismatch or the transport is null", new ErrorContext({
                    id,
                    sfu: this.serverURL,
                    sendTransport: this.sendTransport?.id || "UNKNOWN",
                    recvTransport: this.recvTransport?.id || "UNKNOWN",
                }));
            }
        };
        switch (errorCode) {
            case WebRTCTransportErrorCode.FailedToConnect: {
                const attributes = {
                    state: connectionState || "UNKNOWN",
                    sfu: this.serverURL,
                    direction,
                };
                globalsMetricsManager.addMetricReliably("gvc-peerconnection-failed-connect", attributes);
                Logger.error(`RTCConnectionState is still not connected after ${TRANSPORT_DISCONNECTED_GRACE_PERIOD_MS / 1000} seconds`, new ErrorContext(attributes));
                this.createWebRtcTransports(direction);
                break;
            }
            case WebRTCTransportErrorCode.ICERestartFailure: {
                const attribute = {
                    error: error instanceof Error ? error.name : "",
                    message: error instanceof Error ? error.message : String(error),
                    sfu: this.serverURL,
                    direction,
                };
                globalsMetricsManager.addMetricReliably("gvc-ice-restart-error", attribute);
                Logger.error("failed to restart ICE", new ErrorContext(attribute));
                this.createWebRtcTransports(direction);
                break;
            }
            case WebRTCTransportErrorCode.UnstableConnection: {
                const attribute = {
                    state: connectionState || "UNKNOWN",
                    sfu: this.serverURL,
                    direction,
                };
                globalsMetricsManager.addMetricReliably("gvc-peerconnection-unstable", attribute);
                Logger.error("RTCPeerConnection unstable connectionState", new ErrorContext(attribute));
                this.createWebRtcTransports(direction);
                break;
            }
            case WebRTCTransportErrorCode.RTCPeerConnectionException: {
                const attribute = {
                    error: error instanceof Error ? error.name : "",
                    message: error instanceof Error ? error.message : String(error),
                    sfu: this.serverURL,
                    direction,
                };
                globalsMetricsManager.addMetricReliably("gvc-peerconnection-exception", attribute);
                Logger.error("RTCPeerConnection exception", new ErrorContext(attribute));
                this.createWebRtcTransports(direction);
                break;
            }
            case WebRTCTransportErrorCode.Disconnected: {
                retryWithICERestart();
                break;
            }
            case WebRTCTransportErrorCode.FailedState: {
                retryWithICERestart();
                break;
            }
            default:
                Logger.error(`Unknown WebRTCTransportErrorCode: ${errorCode}`);
        }
    };
    onWebRTCTransportConnectionStateChange = (context) => {
        const { id } = context;
        const isSendTransport = this.sendTransport && id === this.sendTransport.id;
        const isRecvTransport = this.recvTransport && id === this.recvTransport.id;
        const direction = isSendTransport ? "send" : isRecvTransport ? "recv" : undefined;
        if (direction) {
            this.externalEventEmitter.publishWebRTCTransportConnectionStateChange({
                ...context,
                sfuAddr: this.serverURL,
                direction,
            });
        }
    };
    constructor(eventEmitter, statsManager) {
        this.externalEventEmitter = eventEmitter;
        this.rtcStatsManager = statsManager;
        this.connectionAttemptCounter = new ConnectionAttemptCounter();
        this.cleanupFns = [
            this.internalEventEmitter.addEventListener(GVCInternalEvent.WebRTCTransportError, this.onWebRTCTransportError),
            this.internalEventEmitter.addEventListener(GVCInternalEvent.WebRTCTransportConnectionStateChange, this.onWebRTCTransportConnectionStateChange),
        ];
    }
    async createWebSocketSignaling() {
        const webSocketConnectedPromise = deferredPromise();
        const webSocketConnectionStateChanged = (state, context) => {
            switch (state) {
                case WebSocketConnectionState.Connected: {
                    metricsManager.mediaInterruption.signalingInterruptedEvent(this.serverURL, false);
                    webSocketConnectedPromise.resolve();
                    this.onSFUSignalingConnect();
                    break;
                }
                case WebSocketConnectionState.Disconnected: {
                    const { reason } = context;
                    if (!reason) {
                        Logger.error("Received WebSocketConnectionState.Disconnected without a reason");
                        return;
                    }
                    if (reason === WebSocketDisconnectReason.Unknown) {
                        Logger.error("Received WebSocketDisconnectReason.Unknown");
                    }
                    Object.values(this.info).forEach((info) => {
                        info.state = ConsumerState.ConnectingToSFU;
                    });
                    this.onInfo(this.info);
                    metricsManager.mediaInterruption.signalingInterruptedEvent(this.serverURL, true);
                    webSocketConnectedPromise.reject(new Error(reason));
                    this._reloadWithDelay();
                }
            }
        };
        const serverShouldSendStats = gatherVideoClientDataSource.gate(GatedFeatName.VideoServerStats, this.id, this.room);
        const signalingOptions = { sessionId: tracker.sessionId, serverStats: serverShouldSendStats };
        const signaling = new Signaling(this.serverURL, this.room, this.id, signalingOptions);
        signaling.addEventListener(GVCInternalEvent.WebSocketConnectionStateChange, webSocketConnectionStateChanged, { leading: true });
        try {
            await Promise.race([
                webSocketConnectedPromise.promise,
                this.destroyedPromise.promise.then(() => {
                    throw new Error("SFUClient was destroyed during WebSocket connection");
                }),
            ]);
            if (this.destroyed) {
                this.signaling?.destroy();
                throw new Error("SFUClient was destroyed during WebSocket connection");
            }
            this.continuousConnectionFailureCount = 0;
        }
        catch (error) {
            this.continuousConnectionFailureCount++;
            const additionalContext = {
                error: error instanceof Error ? error.name : "",
                message: error instanceof Error ? error.message : String(error),
                allowed: Array.from(this.allowed),
                subscribed: Object.keys(this.subscribed),
                failedCount: this.continuousConnectionFailureCount,
            };
            this.onWebSocketFailedToConnect(additionalContext);
            delete this.signaling;
            delete this.device?.signaling;
            throw error;
        }
        return signaling;
    }
    createWebRtcTransports(direction) {
        this._clearWebRTCTransport(direction);
        if (!this.signaling || !this.device || this.destroyed)
            return;
        if (!direction || direction === "send") {
            this.produceQ = new ExecutionQueue();
            this.sendTransport = new SignaledTransport(this.serverURL, this.signaling, this.device, this.internalEventEmitter, "send", this.rtcStatsManager, this.iceTransportRequestOptions, this.turnProvider);
            if (this.finishedInitialStart && this.tracks.size > 0) {
                this.tracks = new Map();
                this.onProducerSfuConnected(this.serverURL);
            }
        }
        if (!direction || direction === "recv") {
            this.consumeQ = new ExecutionQueue();
            this.recvTransport = new SignaledTransport(this.serverURL, this.signaling, this.device, this.internalEventEmitter, "recv", this.rtcStatsManager, this.iceTransportRequestOptions, this.turnProvider);
            if (this.finishedInitialStart) {
                this._reconcileSubscribed();
            }
        }
    }
    async start(serverURL, id, room, iceTransportRequestOptions, onSFUSignalingConnect, turnProvider) {
        this.serverURL = serverURL;
        this.id = id;
        this.room = room;
        this.turnProvider = turnProvider;
        this.iceTransportRequestOptions = iceTransportRequestOptions;
        if (onSFUSignalingConnect) {
            this.onSFUSignalingConnect = onSFUSignalingConnect;
        }
        const handleException = (e) => {
            this.onDeviceConnectError();
            if (!this.finishedInitialStart && this.shouldCancelInitialStart()) {
                this.reloading = false;
                this.onReloadChange(this.reloading);
                this._clear();
                this.rejectInitialStartPromise();
            }
            else {
                this._reloadWithDelay();
            }
            throw e;
        };
        try {
            this.connectionAttemptCounter.recordAttempt();
            this.signaling = await this.createWebSocketSignaling();
            this.signaling.onAnyIncoming(partial(tracker.captureSFUMessage, [this.serverURL, "incoming"]));
            this.signaling.onAnyOutgoing(partial(tracker.captureSFUMessage, [this.serverURL, "outgoing"]));
            this.signaling.on("consume-close", this._onConsumeClose);
            this.signaling.on("consume-connected", this._onConsumeConnected);
            this.signaling.on("consume-over-allowed", this._onConsumeOverAllow);
            this.signaling.on("consume-not-allowed", this._onConsumeNotAllowed);
            this.signaling.on("consume-try", this._onConsumeTry);
            this.signaling.on("disable-video", this._onDisableVideo);
            this.signaling.on("double-connected", this._onDoubleConnected);
            this.signaling.on("move-off", this._onMoveOff);
            this.signaling.on("over-allowed", this._onOverAllow);
            this.signaling.on("producer-paused", this.onProducerPaused);
            this.signaling.on("producer-resumed", this.onProducerResumed);
            this.signaling.on("client-ip-info", this._onClientIpInfo);
            this.signaling.on("remote-score", this._onRemoteScore);
            this.signaling.on("self-produce-scores", this._onSelfProduceScores);
            this.signaling.on("server-info", this._onServerInfo);
            this.signaling.on("set-max-spatial-layer", this._onProducerSpatialLayer);
            this.signaling.on("producer-migrating", this._onProducerMigrating);
            this.signaling.on("producer-migration-completed", this._onProducerMigrationCompleted);
        }
        catch (e) {
            handleException(e);
        }
        if (!this.signaling)
            return;
        if (!this.finishedInitialStart) {
            this.device = new SignaledDevice(this.signaling);
            this.createWebRtcTransports();
            try {
                await this.device?.connect();
            }
            catch (e) {
                handleException(e);
            }
        }
        this.reloading = false;
        this.onReloadChange(this.reloading);
        if (!this.finishedInitialStart) {
            this.finishedInitialStart = true;
            this.resolveInitialStartPromise();
            metricsManager.mediaInterruption.registerSFU(this.serverURL);
        }
        if (this.bandwidthMonitorInterval) {
            clearInterval(this.bandwidthMonitorInterval);
        }
        this.bandwidthMonitorInterval = setInterval(this.inboundBandwidthMonitor, BANDWIDTH_FULFILLMENT_MONITOR_INTERVAL);
    }
    _reloadWithDelay() {
        this.signaling?.destroy();
        delete this.signaling;
        if (!this.signalingReconnectTimer) {
            const reloadDelay = getReloadDelayMs(this.connectionAttemptCounter.attemptsInLast30s);
            this.signalingReconnectTimer = window.setTimeout(() => {
                this.reload();
            }, reloadDelay);
        }
    }
    destroy() {
        this.destroyed = true;
        this.destroyedPromise.resolve();
        this._clear();
    }
    _clearWebSocketSignaling() {
        if (this.signalingReconnectTimer) {
            clearTimeout(this.signalingReconnectTimer);
        }
        delete this.signalingReconnectTimer;
        this.device?.destroy();
        this.signaling?.destroy();
    }
    _clearWebRTCTransport(direction) {
        if (!direction || direction === "send") {
            this.sendTransport?.destroy();
            this.produceQ.destroy();
            this.producers.forEach((producer, kind) => {
                if (producer && !producer.closed) {
                    this.onProduceClose(kind);
                }
                this._closeProducer(kind);
            });
        }
        if (!direction || direction === "recv") {
            this.videoTrackCheckOutputTimeouts.forEach((timeout) => clearTimeout(timeout));
            this.videoTrackCheckOutputTimeouts.clear();
            this.recvTransport?.destroy();
            this.consumeQ.destroy();
            this.consumers.forEach((srcConsumers, srcId) => {
                srcConsumers.forEach((_consumer, kind) => {
                    this._closeConsumerUnsignaled(srcId, kind);
                });
            });
            this.consumers = new Map();
            this.recyclableConsumers.forEach((srcConsumers, srcId) => {
                srcConsumers.forEach((_consumer, kind) => {
                    this._closeConsumerUnsignaled(srcId, kind);
                });
            });
            this.recyclableConsumers = new Map();
            this.pausedConsumers = new Set();
            this.prevConsumerStats = new Map();
            this.prevScreenshareConsumerStats = new Map();
            this._lastMaxConsumerLayers = {};
        }
    }
    _clear() {
        this.cleanupFns.forEach((f) => f());
        clearInterval(this.bandwidthMonitorInterval);
        metricsManager.mediaInterruption.unregisterSFU(this.serverURL);
        this._clearWebSocketSignaling();
        this._clearWebRTCTransport();
    }
    _DEBUG_disconnect() {
        this.signaling?.publishWebSocketConnectionStateChange(WebSocketConnectionState.Disconnected, {
            serverURL: this.serverURL,
            reason: WebSocketDisconnectReason.TransportError,
        });
        this._clear();
    }
    debugConsumer(srcId, srcStreamId, tags) {
        this.signaling?.emit("debug-consumer", {
            srcId,
            srcStreamId,
            tags,
        });
    }
    _DEBUG_consumers() {
        Array.from(this.consumers).map(([playerId, subscription]) => {
            this.debugConsumer(playerId, this.room, Array.from(subscription).map(([kind, _consumer]) => kind));
        });
    }
    _compareWithSFUMediaStates(playerData) {
        const localTransports = [];
        if (this.sendTransport?.transport?.id) {
            localTransports.push({ id: this.sendTransport?.transport?.id, direction: "send" });
        }
        if (this.recvTransport?.transport?.id) {
            localTransports.push({ id: this.recvTransport?.transport?.id, direction: "recv" });
        }
        const sortedLocalTransport = sortBy(localTransports, (t) => t.direction);
        if (!isEqual(sortedLocalTransport, playerData?.transports)) {
            debugLogMajorEvent(`[${this.serverURL}] transports is different: ${JSON.stringify(sortedLocalTransport)}, will re-create WebRTC transports`);
            return true;
        }
        const sanitizedProducers = playerData?.producers?.map(({ paused, ...rest }) => rest);
        const localProducers = Array.from(this.producers).map(([kind, producer]) => ({
            kind,
            id: producer.id,
        }));
        const sortedLocalProducers = sortBy(localProducers, [(p) => p.kind]);
        if (!isEqual(sortedLocalProducers, sanitizedProducers)) {
            debugLogMajorEvent(`[${this.serverURL}] producers is different: ${JSON.stringify(sortedLocalProducers)}, will re-create WebRTC transports`);
            return true;
        }
        const sanitizedSubscriptions = playerData?.subscriptions?.map(({ playerId, consumers }) => ({
            playerId,
            consumers: consumers?.map(({ producerPaused, ...rest }) => rest),
        }));
        const combinedConsumers = new Map(this.consumers);
        this.recyclableConsumers.forEach((consumers, playerId) => {
            consumers.forEach((consumer, kind) => {
                const onePlayerConsumers = combinedConsumers.get(playerId) || new Map();
                onePlayerConsumers.set(kind, consumer.consumer);
                combinedConsumers.set(playerId, onePlayerConsumers);
            });
        });
        const localSubscriptions = Array.from(combinedConsumers).map(([playerId, subscription]) => {
            const rawConsumers = Array.from(subscription).map(([kind, consumer]) => ({
                kind,
                id: consumer.id,
            }));
            const consumers = sortBy(rawConsumers, [(c) => c.kind]);
            return { playerId, consumers };
        });
        const sortedLocalSubscriptions = sortBy(localSubscriptions, [(s) => s.playerId]);
        if (!isEqual(sortedLocalSubscriptions, sanitizedSubscriptions)) {
            debugLogMajorEvent(`[${this.serverURL}] subscriptions is different: ${JSON.stringify(sortedLocalSubscriptions)}, will re-create WebRTC transports`);
            return true;
        }
        this.producers.forEach((producer) => {
            const { kind, paused } = playerData?.producers?.filter((p) => p.id === producer.id)[0] || {};
            if (!kind)
                return;
            if (paused === undefined) {
                Logger.error("old version of SFU, paused not presented");
                return;
            }
            Logger.log(`server reported producer ${producer.id} is ${paused}, local state is ${producer.paused}`);
            producer.paused
                ? this.signaling?.emit("produce-pause", { tag: kind })
                : this.signaling?.emit("produce-resume", { tag: kind });
        });
        playerData.subscriptions?.forEach(({ playerId, consumers }) => {
            Object.values(consumers).forEach((consumer) => {
                consumer.producerPaused
                    ? this.onProducerPaused({ srcId: playerId, tag: consumer.kind })
                    : this.onProducerResumed({ srcId: playerId, tag: consumer.kind });
            });
        });
        debugLogMajorEvent(`[${this.serverURL}] media states are in-sync, ${JSON.stringify(playerData)}`);
        return false;
    }
    _reconcileAllowed(playerData) {
        const allowedOnServer = playerData?.allowedConsume ?? [];
        const allowedLocally = Array.from(this.allowed);
        const sortedArray = sortBy(allowedLocally);
        if (!isEqual(allowedOnServer, sortedArray)) {
            debugLogMajorEvent(`local allow list ${sortedArray} does not match server allowed list ${playerData?.allowedConsume}`);
        }
        allowedOnServer?.forEach((id) => {
            if (!allowedLocally.includes(id)) {
                this.allowed.add(id);
                this.disallow(id);
            }
        });
        allowedLocally.forEach((id) => {
            if (!allowedOnServer?.includes(id)) {
                this.allowed.delete(id);
                this.allow(id);
            }
        });
    }
    _reconcileSubscribed() {
        const toSubscribe = this.subscribed;
        this.subscribed = {};
        Object.entries(toSubscribe).forEach(([id, tags]) => {
            this.subscribe(id, tags);
        });
        this.recyclableConsumers.forEach((srcConsumers, srcId) => {
            srcConsumers.forEach((_consumer, kind) => {
                this._asyncCloseConsumer(srcId, kind);
            });
        });
        this.recyclableConsumers = new Map();
    }
    _reconcileProducedTracks(playerData) {
        this.tracks.forEach((track, kind) => {
            const producer = playerData?.producers?.find((p) => p.kind === kind);
            if (!producer) {
                const paused = this.paused.get(kind);
                this.produceStart(kind, track, paused);
            }
        });
    }
    _checkNewWebRtcTransportNeeded(playerData) {
        if (this.sendTransport?.isFailedToConnect() || this.sendTransport?.isClosed()) {
            debugLogMajorEvent(`[${this.serverURL}] sendtransport is already closed`);
            return true;
        }
        if (this.recvTransport?.isFailedToConnect() || this.recvTransport?.isClosed()) {
            debugLogMajorEvent(`[${this.serverURL}] recvTransport is already closed`);
            return true;
        }
        debugLogMajorEvent(`[${this.serverURL}] media states: ${JSON.stringify(playerData)}`);
        return playerData ? this._compareWithSFUMediaStates(playerData) : true;
    }
    async _createNewWebRtcTransportIfNeeded(restartIce) {
        const playerData = await this.signaling?.sendWithResponse("get-player-data");
        if (!playerData) {
            this.createWebRtcTransports();
            return true;
        }
        if (this._checkNewWebRtcTransportNeeded(playerData)) {
            this.createWebRtcTransports();
            this._reconcileAllowed(playerData);
            return true;
        }
        if (this.sendTransport && (this.isIceRestartNeeded(this.sendTransport) || restartIce)) {
            await this.sendTransport.restartIce(IceRestartReason.Reconnect);
        }
        if (this.recvTransport && (this.isIceRestartNeeded(this.recvTransport) || restartIce)) {
            await this.recvTransport.restartIce(IceRestartReason.Reconnect);
        }
        this._reconcileAllowed(playerData);
        this._reconcileSubscribed();
        this._reconcileProducedTracks(playerData);
        Object.values(this.info).forEach((info) => {
            info.state = ConsumerState.Connected;
        });
        this.onInfo(this.info);
        return false;
    }
    async reload(restartIce = false) {
        delete this.signalingReconnectTimer;
        if (this.reloadingLock || this.destroyed)
            return;
        this.connectionAttemptCounter.recordAttempt();
        this.reloadingLock = true;
        this.reloading = true;
        this.onReloadChange(this.reloading);
        Logger.log(`[SFU ${this.serverURL}] fully reloading...`);
        this._clearWebSocketSignaling();
        Object.values(this.info).forEach((info) => {
            info.state = ConsumerState.ConnectingToSFU;
        });
        this.onInfo(this.info);
        try {
            await this.start(this.serverURL, this.id, this.room, this.iceTransportRequestOptions, this.onSFUSignalingConnect, this.turnProvider);
        }
        catch (e) {
            this.reloadingLock = false;
            return;
        }
        if (this.signaling) {
            this.device ? (this.device.signaling = this.signaling) : noop;
            this.sendTransport ? (this.sendTransport.signaling = this.signaling) : noop;
            this.recvTransport ? (this.recvTransport.signaling = this.signaling) : noop;
        }
        try {
            const newTransportCreated = await this._createNewWebRtcTransportIfNeeded(restartIce);
            globalsMetricsManager.addMetricReliably("sfu-reload", {
                mediaReloaded: newTransportCreated.toString(),
            });
        }
        catch (e) {
            this.reloadingLock = false;
            this._reloadWithDelay();
            globalsMetricsManager.addMetricReliably("sfu-reload-saw-exception", {
                sfuAddr: this.serverURL,
            });
            return;
        }
        if (this.destroyed && this.signaling) {
            Logger.log(`[SFU ${this.serverURL}] reload aborted`);
            this._clearWebSocketSignaling();
            return;
        }
        Logger.log(`[SFU ${this.serverURL}] fully reloaded!`);
        this.reloadingLock = false;
        this.reloading = false;
        this.onReloadChange(this.reloading);
    }
    _onDisableVideo = () => {
        this.onDisableVideo();
    };
    _onDoubleConnected = () => {
        if (gatherVideoClientDataSource.gate(GatedFeatName.ReloadSfuOnDoubleConnect, null, this.room)) {
            this.reload();
            const message = "Client double connected";
            const reason = VIDEO_SYSTEM_AUTOMATED_REPORT;
            this.sendDebugReport(message, reason);
        }
        else {
            this.onDisableVideo();
        }
    };
    _onSelfProduceScores = (data) => {
        const kind = data.kind;
        let score = undefined;
        if (data.scores.length === 1) {
            score = data.scores[0]?.score;
        }
        else if (kind === "video") {
            const encodingParameters = this.producers.get("video")?.rtpSender?.getParameters().encodings;
            const activeRids = encodingParameters
                ?.filter((encoding) => encoding.active)
                .map((e) => e.rid);
            const sanitizedScores = data.scores.filter((score) => activeRids?.includes(score.rid));
            score = sanitizedScores.length > 0 ? Math.min(...sanitizedScores.map((s) => s.score)) : 10;
        }
        else {
            Logger.error("unexpected self produce scores", kind, data.scores);
        }
        this.onSelfProduceScore({ kind, score });
    };
    _onRemoteScore = ({ id, kind, consumerScore, producerScore, }) => {
        const remotePlayer = this.info[id];
        if (!remotePlayer)
            return;
        const updateProducerScore = producerScore !== remotePlayer.producerScores[kind];
        const updateConsumerScore = consumerScore !== remotePlayer.consumerScores[kind];
        if (updateProducerScore) {
            remotePlayer.producerScores[kind] = producerScore;
        }
        if (updateConsumerScore) {
            remotePlayer.consumerScores[kind] = consumerScore;
        }
        if (updateProducerScore || updateConsumerScore) {
            this.onInfo(this.info);
        }
    };
    onProducerPaused = ({ srcId, tag }) => {
        this.setStreamEnabled(srcId, tag, false);
    };
    onProducerResumed = ({ srcId, tag }) => {
        this.setStreamEnabled(srcId, tag, true);
    };
    _updateVideoEncodingsAndSpatialLayer = debounceAsync(async (layer) => {
        await this.setMaxProducerSpatialLayer("video", layer);
    });
    _onProducerSpatialLayer = async ({ kind, layer }) => {
        if (kind === "video") {
            await this._updateVideoEncodingsAndSpatialLayer(layer);
        }
    };
    _onProducerMigrating = ({ srcId }) => {
        const info = this.info[srcId];
        if (info) {
            info.migration = MigrationState.InProgress;
            this.onInfo(this.info);
        }
    };
    _onProducerMigrationCompleted = ({ srcId }) => {
        const info = this.info[srcId];
        if (info) {
            info.migration = MigrationState.Completed;
            this.onInfo(this.info);
        }
    };
    _onMoveOff = async (_data, callback) => {
        const { succeed, newSfu } = await this.onMoveOff();
        globalsMetricsManager.addMetricReliably("move-off", {
            sfuAddr: this.serverURL,
            sfuMoved: String(succeed),
            newSfu,
        });
        callback?.({ sfuMoved: succeed });
    };
    _onConsumeOverAllow = ({ srcId, reason }) => {
        const info = this.info[srcId];
        if (info && !info.overAllowed) {
            info.overAllowed = true;
            info.overAllowedReason = reason;
            this.onInfo(this.info);
        }
    };
    _onOverAllow = (over) => {
        this.onOverAllow(over);
    };
    onClientIpInfo;
    _onClientIpInfo = (data) => {
        if (data.vpnDetected) {
            globalsMetricsManager.addMetricReliably("sfu-client-ip-info", {
                vpnDetected: data.vpnDetected,
            });
        }
        this.onClientIpInfo?.(data);
    };
    _onServerInfo = (data) => {
        if (this.recvTransport?.transport?.id === data.transport.id) {
            this.recvTransport.setAvailableRecvBandwidth(data.transport.availableBitrate, data.transport.bitrate);
        }
        if (data.producers) {
            const producersLong = {};
            Object.entries(data.producers).forEach(([kind, producingStreamsStats]) => {
                const kindLong = kindLongFormat(kind);
                producersLong[kindLong] = producingStreamsStats.map((producingStreamStats) => {
                    const pStatLong = statsArrayToObj(producingStreamStats.p);
                    if (!producingStreamStats.c) {
                        return {
                            producer: pStatLong,
                        };
                    }
                    const cStatsLong = {};
                    Object.entries(producingStreamStats.c).forEach(([srcId, statString]) => {
                        cStatsLong[srcId] = statsArrayToObj(statString);
                    });
                    return {
                        producer: pStatLong,
                        consumers: cStatsLong,
                    };
                });
            });
            this.onSFUProducersStats(producersLong);
        }
        if (data.consumers) {
            Object.entries(data.consumers).forEach(([srcId, oneRemotePlayerConsumersStats]) => {
                const oneRemotePlayerConsumers = {};
                Object.entries(oneRemotePlayerConsumersStats).forEach(([kind, stats]) => {
                    const kindLong = kindLongFormat(kind);
                    const pStatLong = statsArrayToObj(stats.p);
                    const cStatLong = statsArrayToObj(stats.c);
                    oneRemotePlayerConsumers[kindLong] = {
                        producer: pStatLong,
                        consumer: cStatLong,
                    };
                });
                this.onSFUConsumersStats(srcId, oneRemotePlayerConsumers);
            });
        }
    };
    allow(id) {
        if (this.allowed.has(id))
            return;
        this.allowed.add(id);
        this.signaling?.emit("consume-allow", {
            dstId: id,
            allowed: true,
        });
    }
    disallow(id) {
        if (!this.allowed.has(id))
            return;
        this.allowed.delete(id);
        this.signaling?.emit("consume-allow", {
            dstId: id,
            allowed: false,
        });
    }
    subscribe(id, tagSet) {
        const currentTags = this.subscribed[id] ?? new Set();
        const tagsToAdd = new Set(Array.from(tagSet).filter((tag) => !currentTags.has(tag)));
        const tagsToRemove = new Set(Array.from(currentTags).filter((tag) => !tagSet.has(tag)));
        this.subscribed[id] = tagSet;
        if (!this.info[id]) {
            this.info[id] = createConsumerInfo(ConsumerState.ConnectingToSFU, id);
            this.onInfo(this.info);
        }
        this.consumeQ
            .run(async () => {
            await this._asyncSubscribe(id, tagsToAdd, tagsToRemove, tagSet.size === 0);
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    unsubscribe(id) {
        if (!this.subscribed[id])
            return;
        delete this.subscribed[id];
        this.consumeQ
            .run(async () => {
            await this._asyncUnsubscribe(id);
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    _onConsumeNotAllowed = ({ srcId }) => {
        this.consumeQ
            .run(async () => {
            const info = this.info[srcId];
            if (info) {
                info.state = ConsumerState.NotAllowed;
                this.onInfo(this.info);
            }
            videoPerformanceTracker.markStatic(VideoPerformanceStages.ConsumePermissionPending, srcId);
        })
            .catch(ignoreExecutionQueueExceptions);
    };
    _onConsumeTry = ({ srcId, srcStreamId, producerIdMap }) => {
        this._trackConsumePermissionPending(srcId);
        this._trackConsumeTry(srcId, producerIdMap);
        return this.consumeQ
            .run(async () => {
            await this._asyncOnConsumeTry(srcId, srcStreamId, producerIdMap);
        })
            .catch(ignoreExecutionQueueExceptions);
    };
    _onConsumeClose = ({ srcId, tag, consumerId }) => {
        this.consumeQ
            .run(async () => {
            await this._asyncOnConsumeClose(srcId, tag, consumerId);
        })
            .catch(ignoreExecutionQueueExceptions);
    };
    _onConsumeConnected = ({ srcId, isConnected }) => {
        this.consumeQ
            .run(async () => {
            const info = this.info[srcId];
            if (!info)
                return;
            if (isConnected) {
                if (info.state === ConsumerState.ProducerDisconnected) {
                    info.state = ConsumerState.Consuming;
                }
            }
            else {
                info.state = ConsumerState.ProducerDisconnected;
            }
            this.onInfo(this.info);
        })
            .catch(ignoreExecutionQueueExceptions);
    };
    async _asyncSubscribe(id, tagsToAdd, tagsToRemove, forceSendConsumeRequest = false) {
        this.actuallySubscribed[id] = true;
        const idInfo = this.info[id];
        await Promise.all(Array.from(tagsToRemove, (kind) => this._asyncRecycleConsumer(id, kind)));
        let resumedConsumer = 0;
        Array.from(tagsToAdd).forEach((kind) => {
            const existingConsumer = this.recyclableConsumers.get(id)?.get(kind);
            if (existingConsumer && idInfo) {
                this.deleteRecycledConsumer(id, kind);
                const realConsumers = this.consumers.get(id);
                if (!realConsumers) {
                    this.consumers.set(id, new Map([[kind, existingConsumer.consumer]]));
                }
                else {
                    realConsumers.set(kind, existingConsumer.consumer);
                }
                this._asyncResumeConsumer(id, kind);
                resumedConsumer++;
                idInfo.enabled[kind] = true;
            }
        });
        if (resumedConsumer === tagsToAdd.size && !forceSendConsumeRequest) {
            this.onInfo(this.info);
            return;
        }
        if (idInfo) {
            idInfo.state = ConsumerState.Consuming;
        }
        else {
            this.info[id] = createConsumerInfo(ConsumerState.Consuming, id);
        }
        this.onInfo(this.info);
        videoPerformanceTracker.markStatic(VideoPerformanceStages.ConsumeRequest, id, true);
        this.signaling?.emit("consume-request", {
            srcId: id,
            srcStreamId: this.room,
            requested: true,
        });
    }
    async _asyncUnsubscribe(id) {
        delete this.actuallySubscribed[id];
        const info = this.info[id];
        info?.video?.clear();
        info?.screenVideo?.clear();
        delete this.info[id];
        this.onInfo(this.info);
        try {
            await this.signaling?.sendWithResponse("consume-request", {
                srcId: id,
                srcStreamId: this.room,
                requested: false,
            });
        }
        catch (e) {
            Logger.warn(`consume-request for unsubscribe to ${id} failed`);
        }
        this.recvTransport?.cancelPendingConsume(id);
        const idConsumers = this.consumers.get(id);
        if (idConsumers) {
            idConsumers.forEach((_consumer, kind) => {
                this._closeConsumerUnsignaled(id, kind);
            });
            this.consumers.delete(id);
        }
        const recyclableConsumers = this.recyclableConsumers.get(id);
        if (recyclableConsumers) {
            recyclableConsumers.forEach((_consumer, kind) => {
                this._closeConsumerUnsignaled(id, kind);
                this.deleteRecycledConsumer(id, kind);
            });
        }
        this.prevConsumerStats.delete(id);
        this.prevScreenshareConsumerStats.delete(id);
        delete this._lastMaxConsumerLayers[id];
    }
    async _asyncOnConsumeTry(srcId, srcStreamId, producerIdMap) {
        const subscribedTags = this.subscribed[srcId];
        const userInfo = this.info[srcId];
        if (userInfo) {
            userInfo["videoEnabled"] = producerIdMap["video"] ? true : false;
            this.onInfo(this.info);
        }
        if (!this.actuallySubscribed[srcId])
            return;
        const dispatchInfo = () => {
            const idInfo = this.info[srcId];
            if (!idInfo)
                return;
            idInfo.state = ConsumerState.Connected;
            idInfo.overAllowed = false;
            idInfo.overAllowedReason = "";
            this.onInfo(this.info);
        };
        if (!subscribedTags || subscribedTags.size === 0) {
            dispatchInfo();
            return;
        }
        for (const kind of Array.from(subscribedTags)) {
            const producerId = producerIdMap[kind];
            if (!producerId) {
                videoPerformanceTracker.clearMarksAndMeasures(srcId, kind);
                videoPerformanceTracker.clearStatic(VideoPerformanceStages.ConsumeTry, `${srcId}-${kind}`);
                dispatchInfo();
                continue;
            }
            const existingConsumer = this.consumers.get(srcId)?.get(kind);
            if (existingConsumer &&
                !existingConsumer.closed &&
                existingConsumer.producerId === producerId) {
                videoPerformanceTracker.clearStatic(VideoPerformanceStages.ConsumeTry, `${srcId}-${kind}`);
                if (this.pausedConsumers.has(existingConsumer.id)) {
                    this._asyncPauseConsumer(srcId, kind);
                }
                else {
                    this._asyncResumeConsumer(srcId, kind);
                }
                dispatchInfo();
                continue;
            }
            const existingRecylableConsumer = this.recyclableConsumers.get(srcId)?.get(kind)?.consumer;
            if (existingRecylableConsumer &&
                !existingRecylableConsumer.closed &&
                existingRecylableConsumer.producerId === producerId) {
                this._asyncPauseConsumer(srcId, kind);
                dispatchInfo();
                continue;
            }
            const spatialLayer = kind === "video" ? this.getMaxConsumerSpatialLayer(srcId, kind) : undefined;
            const onSuccess = (consumer) => {
                if (!this.subscribed[srcId]) {
                    consumer.close();
                    return;
                }
                if (kind === "video") {
                    this._lastMaxConsumerLayers[consumer.id] = {
                        spatialLayer: spatialLayer ?? 0,
                        temporalLayer: DEFAULT_TEMPORAL_LAYER,
                        timestamp: gatherVideoClientDataSource.performance().timeOrigin +
                            gatherVideoClientDataSource.performance().now(),
                    };
                }
                this._addConsumer(srcId, kind, consumer);
                this.purgeRecycledConsumersIfNeeded();
                dispatchInfo();
            };
            const onError = (e) => {
                Logger.error(`Failed to consume`, new ErrorContext({
                    kind,
                    srcId,
                    sfu: this.serverURL,
                    producerId,
                }, e));
                this.setStreamEnabled(srcId, kind, false);
                videoPerformanceTracker.clearMarksAndMeasures(srcId, kind);
                if (e instanceof Error && e.message && e.message.includes("RTCPeerConnection")) {
                    Logger.info("recover recv transport upon RTCPeerConnection exception");
                    setTimeout(() => {
                        this.internalEventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.RTCPeerConnectionException, {
                            sfuAddr: this.serverURL,
                            id: this.recvTransport?.id ?? "UNKNOWN",
                            error: e,
                        });
                    }, 0);
                }
                else if (this.recvTransport?.shouldRetryConsumeRequest && this.signaling) {
                    this.recvTransport.shouldRetryConsumeRequest = false;
                    this.signaling.emit("consume-request", {
                        srcId,
                        srcStreamId: this.room,
                        requested: true,
                    });
                }
                else if (typeof e === "string" &&
                    e.includes("sendWithResponse for consume timed out") &&
                    this.signaling) {
                    this.signaling.emit("consume-request", {
                        srcId,
                        srcStreamId: this.room,
                        requested: true,
                    });
                }
            };
            try {
                if (this.recvTransport) {
                    if (!this.recvTransport.created) {
                        try {
                            await this.recvTransport.connect("recv");
                        }
                        catch (e) {
                            debugLogMajorEvent(`Recv transport on ${this.serverURL} failed to connect ${e}`);
                            this.recvTransport.failedToConnect = true;
                            this._reloadWithDelay();
                            return;
                        }
                    }
                    else if (this.isIceRestartNeeded(this.recvTransport)) {
                        this.recvTransport.restartIce(IceRestartReason.Consume);
                    }
                    this._trackConsumeTryEnd(srcId, kind);
                    if (!gatherVideoClientDataSource.gate(GatedFeatName.UnthrottledSubscribe, this.id, this.room)) {
                        const consumer = await this.recvTransport.consume(srcId, srcStreamId, kind, spatialLayer, (producerPaused) => {
                            this.setStreamEnabled(srcId, kind, !producerPaused);
                        });
                        onSuccess(consumer);
                    }
                    else {
                        this.recvTransport?.batchConsume(srcId, srcStreamId, kind, onSuccess, (e) => {
                            Logger.error("batchConsume failed with error", e);
                            setTimeout(() => {
                                this.createWebRtcTransports("recv");
                            }, 0);
                        }, spatialLayer, (producerPaused) => {
                            this.setStreamEnabled(srcId, kind, !producerPaused);
                        });
                    }
                }
            }
            catch (e) {
                if (typeof e === "string" || e instanceof Error) {
                    onError(e);
                }
            }
        }
    }
    async _asyncOnConsumeClose(srcId, tag, consumerId) {
        const existingConsumerId = this.consumers.get(srcId)?.get(tag)?.id;
        const existingRecyclableConsumerId = this.recyclableConsumers.get(srcId)?.get(tag)?.consumer.id;
        if ((existingConsumerId && existingConsumerId === consumerId) ||
            (existingRecyclableConsumerId && existingRecyclableConsumerId === consumerId)) {
            this._closeConsumerUnsignaled(srcId, tag);
        }
    }
    isProducing() {
        return this.producers.size > 0;
    }
    isIceRestartNeeded(transport) {
        return (!transport.isClosed() &&
            (transport.transport?.connectionState === "disconnected" ||
                transport.transport?.connectionState === "failed"));
    }
    produceStart(kind, track, pause = false) {
        this.tracks.set(kind, track);
        this.paused.set(kind, pause);
        return this.produceQ
            .run(async () => {
            if (!this.sendTransport)
                return false;
            if (!this.tracks.get(kind) || this.tracks.get(kind) !== track)
                return false;
            const screenShareHighQuality = shouldUseHighQualityScreenshare(track);
            const existingProducer = this.producers.get(kind);
            const producerConfig = getProducerConfig(kind, track, screenShareHighQuality, this.getLocalVideoCaptureResolution());
            const needToReproduce = (kind === "screen" &&
                screenShareHighQuality !== this.sendTransport.screenShareHighQuality) ||
                (kind === "video" &&
                    producerConfig.encodings?.length !== this.sendTransport.encodingParamsSize);
            if (existingProducer && !needToReproduce) {
                if (track.readyState === "ended") {
                    Logger.error("replacing with an ended track, we're not sure if this is a problem");
                }
                existingProducer.replaceTrack({ track }).catch((e) => {
                    Logger.error("Failed to replace track", new ErrorContext({ trackId: track.id, kind, label: track.label, readyState: track.readyState }, e));
                });
                if (existingProducer.paused && !pause) {
                    this._produceResumeAsync(kind);
                }
                else if (!existingProducer.paused && pause) {
                    this._producePauseAsync(kind);
                }
                return true;
            }
            if (!this.sendTransport.created) {
                try {
                    await this.sendTransport.connect("send");
                }
                catch (e) {
                    debugLogMajorEvent(`Send transport on ${this.serverURL} failed to connect ${e}`);
                    this.sendTransport.failedToConnect = true;
                    this._reloadWithDelay();
                    return false;
                }
            }
            else if (this.isIceRestartNeeded(this.sendTransport)) {
                await this.sendTransport.restartIce(IceRestartReason.Produce);
                const { promise, resolve, reject } = deferredPromise();
                const connectionStateCheckInterval = setInterval(() => {
                    if (this.sendTransport?.transport?.connectionState === "connected") {
                        Logger.info("send transport successfully restarted ICE during produce");
                        resolve();
                    }
                }, 10);
                const timeout = setTimeout(() => {
                    Logger.info("send transport failed restarted ICE during produce");
                    reject();
                }, 10000);
                try {
                    await promise;
                }
                catch {
                    this.createWebRtcTransports("send");
                    return false;
                }
                finally {
                    clearInterval(connectionStateCheckInterval);
                    clearTimeout(timeout);
                }
            }
            this._closeProducer(kind);
            if (kind === "video" && producerConfig.encodings) {
                this.maxProducerSpatialLayer = VideoSpatialLayer.LowQuality;
                setProducerEncodingsByQuality(producerConfig.encodings, {
                    high: false,
                    mid: false,
                    low: true,
                });
            }
            const producer = await this.sendTransport.produce(kind, screenShareHighQuality ? { screenShareHighQuality: true } : {}, producerConfig);
            if (!this.tracks.get(kind) || this.tracks.get(kind) !== track) {
                producer.close();
                return false;
            }
            this._addProducer(kind, producer);
            if (pause) {
                this._producePauseAsync(kind);
            }
            if (kind === "video") {
                await this._updateVideoEncodingsAndSpatialLayer(this.maxProducerSpatialLayer);
            }
            return true;
        })
            .catch((e) => {
            if (e instanceof Error && e.message && e.message.includes("RTCPeerConnection")) {
                Logger.info("recover send transport upon RTCPeerConnection exception");
                setTimeout(() => {
                    this.internalEventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.RTCPeerConnectionException, {
                        sfuAddr: this.serverURL,
                        id: this.sendTransport?.id ?? "UNKNOWN",
                        error: e,
                    });
                }, 0);
                return false;
            }
            ignoreExecutionQueueExceptions(e);
            return false;
        });
    }
    produceEnd(kind) {
        this.paused.delete(kind);
        this.tracks.delete(kind);
        this.produceQ
            .run(async () => {
            this._closeProducer(kind);
            this.signaling?.emit("produce-close", {
                tag: kind,
            });
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    _produceResumeAsync(kind) {
        const producer = this.producers.get(kind);
        if (!producer) {
            const track = this.tracks.get(kind);
            if (track) {
                track.enabled = true;
            }
            return;
        }
        producer.resume();
        this.signaling?.emit("produce-resume", { tag: kind });
    }
    produceResume(kind) {
        this.paused.set(kind, false);
        this.produceQ
            .run(async () => {
            this._produceResumeAsync(kind);
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    _producePauseAsync(kind) {
        const producer = this.producers.get(kind);
        if (!producer) {
            const track = this.tracks.get(kind);
            if (track) {
                track.enabled = false;
            }
            return;
        }
        producer.pause();
        this.signaling?.emit("produce-pause", { tag: kind });
    }
    producePause(kind) {
        this.paused.set(kind, true);
        this.produceQ
            .run(async () => {
            this._producePauseAsync(kind);
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    async setMaxProducerSpatialLayer(tag, spatialLayer) {
        this.maxProducerSpatialLayer = spatialLayer;
        try {
            await this.producers.get(tag)?.setMaxSpatialLayer(spatialLayer);
        }
        catch (e) {
            Logger.error("unable to set max spatial layer", buildErrorContext(e));
        }
    }
    async setConsumePriorityByTag(tag, priorities) {
        await this._sendSetConsumePriorityMessage(tag, priorities);
    }
    async setMaxConsumerLayers(id, tag, spatialLayer, temporalLayer) {
        const consumer = this.consumers.get(id)?.get(tag);
        if (!consumer)
            return;
        if (this._lastMaxConsumerLayers[consumer.id]?.spatialLayer === spatialLayer &&
            this._lastMaxConsumerLayers[consumer.id]?.temporalLayer === temporalLayer) {
            return;
        }
        const newLayer = spatialLayer ?? this.defaultMaxConsumerSpatialLayer;
        await this._sendSetConsumeSpatialMessage(id, tag, newLayer, temporalLayer);
        this._lastMaxConsumerLayers[consumer.id] = {
            spatialLayer: newLayer,
            temporalLayer: temporalLayer ?? DEFAULT_TEMPORAL_LAYER,
            timestamp: gatherVideoClientDataSource.performance().timeOrigin +
                gatherVideoClientDataSource.performance().now(),
        };
    }
    requestSFUDebug(srcIds, srcStreamId) {
        this.signaling?.emit("debug-sfu", { srcIds, srcStreamId });
    }
    requestProfiling(start) {
        if (start) {
            this.signaling?.emit("start-profiling");
        }
        else {
            this.signaling?.emit("stop-profiling");
        }
    }
    isSubscribed(srcId, kind) {
        const subscribedTags = this.subscribed[srcId];
        return subscribedTags && subscribedTags.has(kind);
    }
    _getVideoElement(info, kind) {
        if (kind === "audio" || kind === "video") {
            return info.video;
        }
        else if (kind === "sound" || kind === "screen") {
            return info.screenVideo;
        }
        else {
            throw new Error("Unexpected kind " + kind);
        }
    }
    setStreamEnabled(srcId, kind, enabled) {
        const info = this.info[srcId];
        if (info) {
            if (kind === "audio" && info.enabled[kind] === true && enabled === false) {
                info.lastAudioMutedTimestamp = gatherVideoClientDataSource.performance().now();
            }
            info.enabled[kind] = enabled;
            this.onInfo(this.info);
            const video = this._getVideoElement(info, kind);
            const muted = !enabled;
            const mediaKind = ConsumerKindToMediaKind(kind);
            video?.setMute("producer", mediaKind, muted);
        }
        this._onConsumerEnableOrDisable(srcId, kind);
    }
    _addProducer(kind, producer) {
        this._closeProducer(kind);
        this.producers.set(kind, producer);
    }
    _closeProducer(kind) {
        const producer = this.producers.get(kind);
        if (!producer)
            return;
        producer.close();
        this.producers.delete(kind);
        this.onSelfProduceScore({
            kind,
            score: undefined,
        });
    }
    _addConsumer(srcId, kind, consumer) {
        const srcConsumers = this.consumers.get(srcId);
        if (srcConsumers) {
            this._closeConsumerUnsignaled(srcId, kind, false);
            srcConsumers.set(kind, consumer);
        }
        else {
            const newConsumers = new Map();
            newConsumers.set(kind, consumer);
            this.consumers.set(srcId, newConsumers);
        }
        this.externalEventEmitter.publishEvent(GVCInternalEvent.ConsumerCreated, {
            playerId: srcId,
            kind,
            consumer,
        });
        this._onConsumerEnableOrDisable(srcId, kind);
        const info = this.info[srcId];
        if (!info) {
            Logger.error("Expected info, can't add tracks");
            return;
        }
        const video = this._getVideoElement(info, kind);
        if (!video) {
            Logger.error("Expected video, can't add tracks");
            return;
        }
        const measurement = measureAvLoadtime(srcId, kind, this.id);
        if (measurement) {
            globalsMetricsManager.addMetricReliably("avLoadTime", measurement);
        }
        video.addTrack(consumer.track);
        if (consumer.track.readyState === "ended") {
            globalsMetricsManager.addMetricReliably("rtcTrackEndedOnArrival", {
                tag: kind,
                srcId,
                mid: consumer.rtpParameters.mid ?? 0,
            });
        }
        else {
            checkVideoTrackHasOutputAfterFiveSec(consumer, this.videoTrackCheckOutputTimeouts);
        }
        if (consumer && consumer.rtpReceiver) {
            this._startTrackingIncomingPackets(this.id, srcId, kind, consumer.rtpReceiver);
        }
    }
    _stopTrackingIncomingPackets(id, remoteId, kind) {
        LOG_TO_NEWRELIC_TIMEOUTS_S.forEach((timeout) => {
            videoPerformanceTracker.clearTimeout(`${VideoPerformanceStages.RtpInspection}-${id}-${remoteId}-${kind}-${timeout}`);
        });
    }
    _startTrackingIncomingPackets(id, remoteId, kind, rtpSender) {
        LOG_TO_NEWRELIC_TIMEOUTS_S.forEach((timeout) => {
            videoPerformanceTracker.addTimeout(`${VideoPerformanceStages.RtpInspection}-${id}-${remoteId}-${kind}-${timeout}`, () => {
                const stats = this.rtcStatsManager.getCachedRecvTransceiverStats(this.serverURL, rtpSender);
                let bytesReceived = 0;
                Object.values(stats).forEach((r) => {
                    if (r.type.includes("inbound-rtp")) {
                        bytesReceived = r.bytesReceived || 0;
                    }
                });
                if (bytesReceived === 0) {
                    globalsMetricsManager.addMetricReliably("stuckInRtpInspection", {
                        stage: VideoPerformanceStages.RtpInspection,
                        tag: kind,
                        id,
                        timeout,
                    });
                }
                else {
                    LOG_TO_NEWRELIC_TIMEOUTS_S.filter((futureTimeout) => futureTimeout > timeout).forEach((futureTimeout) => {
                        videoPerformanceTracker.clearTimeout(`${VideoPerformanceStages.RtpInspection}-${id}-${remoteId}-${kind}-${futureTimeout}`);
                    });
                }
            }, timeout * 1000);
        });
    }
    _closeConsumerUnsignaled(srcId, kind, markDisabled = true) {
        const consumer = this.consumers.get(srcId)?.get(kind) ??
            this.recyclableConsumers.get(srcId)?.get(kind)?.consumer;
        if (!consumer)
            return;
        const info = this.info[srcId];
        if (info) {
            const video = this._getVideoElement(info, kind);
            const trackKind = ["audio", "sound"].includes(kind) ? "audio" : "video";
            video?.removeTrack(trackKind);
            if (markDisabled) {
                if (kind === "audio" && info.enabled[kind] === true) {
                    info.lastAudioMutedTimestamp = gatherVideoClientDataSource.performance().now();
                }
                info.enabled[kind] = false;
            }
            info.producerScores[kind] = 10;
            this.onInfo(this.info);
        }
        this.pausedConsumers.delete(consumer.id);
        consumer.close();
        if (kind === "video" && consumer.id) {
            this.prevConsumerStats.delete(consumer.id);
            delete this._lastMaxConsumerLayers[consumer.id];
        }
        else if (kind === "screen" && consumer.id) {
            this.prevScreenshareConsumerStats.delete(consumer.id);
        }
        this.consumers.get(srcId)?.delete(kind);
        this.deleteRecycledConsumer(srcId, kind);
        this._stopTrackingIncomingPackets(this.id, srcId, kind);
        this.externalEventEmitter.publishEvent(GVCInternalEvent.ConsumerDestroyed, {
            playerId: srcId,
            kind,
            consumer,
        });
    }
    async _asyncPauseConsumer(srcId, kind) {
        const consumer = this.consumers.get(srcId)?.get(kind);
        if (!consumer)
            return;
        this.pausedConsumers.add(consumer.id);
        await this._updateRemoteConsumer(srcId, kind, "consume-pause");
        consumer.pause();
        if (kind === "video") {
            const info = this.info[srcId];
            if (info) {
                const video = this._getVideoElement(info, kind);
                video?.removeTrack("video");
            }
        }
        this.externalEventEmitter.publishEvent(GVCInternalEvent.ConsumerDisabled, {
            playerId: srcId,
            kind,
            consumer,
            side: "consumer",
        });
    }
    pauseConsumer(srcId, kind) {
        this.consumeQ
            .run(async () => {
            this._asyncPauseConsumer(srcId, kind);
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    async _asyncResumeConsumer(srcId, kind) {
        const consumer = this.consumers.get(srcId)?.get(kind);
        if (!consumer)
            return;
        this.pausedConsumers.delete(consumer.id);
        await this._updateRemoteConsumer(srcId, kind, "consume-resume");
        if (consumer.closed)
            return;
        consumer.resume();
        if (kind === "video") {
            const info = this.info[srcId];
            if (info) {
                const video = this._getVideoElement(info, kind);
                video?.addTrack(consumer.track);
                checkVideoTrackHasOutputAfterFiveSec(consumer, this.videoTrackCheckOutputTimeouts);
            }
        }
        this.externalEventEmitter.publishEvent(GVCInternalEvent.ConsumerEnabled, {
            playerId: srcId,
            kind,
            consumer,
            side: "consumer",
        });
    }
    resumeConsumer(srcId, kind) {
        this.consumeQ
            .run(async () => {
            this._asyncResumeConsumer(srcId, kind);
        })
            .catch(ignoreExecutionQueueExceptions);
    }
    async _updateRemoteConsumer(srcId, kind, message) {
        const consumer = this.consumers.get(srcId)?.get(kind) ??
            this.recyclableConsumers.get(srcId)?.get(kind)?.consumer;
        if (!consumer)
            return;
        try {
            await this.signaling?.sendWithResponse(message, {
                srcId,
                srcStreamId: this.room,
                tag: kind,
                consumerId: consumer.id,
            });
        }
        catch (e) {
            const err = guaranteedError(e);
            Logger.warn(`Failed updating remote consumer, kind ${kind}, action ${message}, for player ${srcId}.`, err);
        }
    }
    async _asyncCloseConsumer(srcId, kind) {
        const consumer = this.consumers.get(srcId)?.get(kind) ??
            this.recyclableConsumers.get(srcId)?.get(kind)?.consumer;
        if (!consumer)
            return;
        try {
            await this._updateRemoteConsumer(srcId, kind, "consume-close");
        }
        catch (e) {
        }
        this._closeConsumerUnsignaled(srcId, kind);
    }
    _asyncRecycleConsumer(srcId, kind) {
        const consumer = this.consumers.get(srcId)?.get(kind);
        if (!consumer)
            return;
        this._asyncPauseConsumer(srcId, kind);
        this.consumers.get(srcId)?.delete(kind);
        const recyclable = this.recyclableConsumers.get(srcId) ??
            new Map();
        const existingConsumer = recyclable.get(kind);
        if (existingConsumer) {
            Logger.error("Recycling consumer that already exists", { srcId, kind });
            existingConsumer.consumer.close();
        }
        recyclable.set(kind, { consumer, timestamp: gatherVideoClientDataSource.performance().now() });
        this.recyclableConsumers.set(srcId, recyclable);
        const info = this.info[srcId];
        if (info) {
            info.enabled[kind] = false;
            info.producerScores[kind] = 10;
            this.onInfo(this.info);
        }
    }
    deleteRecycledConsumer(srcId, kind) {
        this.recyclableConsumers.get(srcId)?.delete(kind);
        if (this.recyclableConsumers.get(srcId)?.size === 0) {
            this.recyclableConsumers.delete(srcId);
        }
    }
    purgeRecycledConsumersIfNeeded() {
        const consumers = Array.from(this.consumers)
            .map(([srcId, consumerMap]) => Array.from(consumerMap).map(([tag, consumer]) => ({ srcId, tag, consumer })))
            .flat();
        const recyclableConsumers = Array.from(this.recyclableConsumers)
            .map(([srcId, consumerMap]) => Array.from(consumerMap).map(([tag, consumer]) => ({ srcId, tag, consumer })))
            .flat();
        const toPurge = Math.min(consumers.length + recyclableConsumers.length - MAX_CONSUMERS_BEFORE_CLOSE, recyclableConsumers.length);
        if (toPurge > 0) {
            Logger.error(`Too many consumers: ${consumers.length} ${recyclableConsumers.length}`);
            const purgeArray = sortBy(recyclableConsumers, (entry) => entry.consumer.timestamp).slice(0, toPurge);
            purgeArray.forEach((consumer) => {
                this._asyncCloseConsumer(consumer.srcId, consumer.tag);
                this.deleteRecycledConsumer(consumer.srcId, consumer.tag);
            });
        }
    }
    _onConsumerEnableOrDisable(srcId, kind) {
        const isEnabled = this.info[srcId]?.enabled[kind];
        const consumer = this.consumers.get(srcId)?.get(kind);
        if (isEnabled === undefined || consumer === undefined)
            return;
        this.externalEventEmitter.publishEvent(isEnabled ? GVCInternalEvent.ConsumerEnabled : GVCInternalEvent.ConsumerDisabled, {
            playerId: srcId,
            kind,
            consumer,
            side: "producer",
        });
    }
    async _sendSetConsumeSpatialMessage(id, tag, spatialLayer, temporalLayer) {
        try {
            const response = await this.signaling?.sendWithResponse("consume-set-spatial", {
                srcId: id,
                srcStreamId: this.room,
                tag,
                spatialLayer: spatialLayer ?? this.defaultMaxConsumerSpatialLayer,
                temporalLayer,
            });
            if (response) {
                Logger.error("consume-set-spatial response error", new ErrorContext({ message: response.error }));
            }
        }
        catch (e) {
            Logger.error("consume-set-spatial response error:", buildErrorContext(e));
        }
    }
    _sendSetConsumePriorityMessage = debounceAsync(async (tag, srcIds) => {
        try {
            const response = await this.signaling?.sendWithResponse("consume-set-priority", {
                srcStreamId: this.room,
                tag,
                srcIds,
            });
            Logger.info("priority for ", tag, response);
        }
        catch (e) {
            Logger.error("consume-set-priority response error:", buildErrorContext(e));
        }
    });
    _trackConsumeTry(srcId, producerIdMap) {
        const consumeRequestTryMeasure = videoPerformanceTracker.measureStatic("consumeRequestToConsumeTry", VideoPerformanceStages.ConsumeRequest, VideoPerformanceStages.ConsumeRequestEnd, srcId);
        if (consumeRequestTryMeasure) {
            globalsMetricsManager.addMetricReliably("avLoadTime", {
                consumeRequestToConsumeTryTime: consumeRequestTryMeasure.duration,
            });
        }
        const subscribedTags = this.subscribed[srcId];
        if (subscribedTags) {
            for (const kind of Array.from(subscribedTags)) {
                if (producerIdMap[kind]) {
                    videoPerformanceTracker.markStatic(VideoPerformanceStages.ConsumeTry, `${srcId}-${kind}`);
                }
            }
        }
    }
    _trackConsumePermissionPending(srcId) {
        const consumePermissionPendingMeasure = videoPerformanceTracker.measureStatic("consumePermissionPendingToConsumeTry", VideoPerformanceStages.ConsumePermissionPending, VideoPerformanceStages.ConsumePermissionPendingEnd, srcId);
        if (consumePermissionPendingMeasure) {
            globalsMetricsManager.addMetricReliably("avLoadTime", {
                consumePermissionPendingTime: consumePermissionPendingMeasure.duration,
            });
        }
    }
    _trackConsumeTryEnd(srcId, kind) {
        const consumeTryToConsumeMeasure = videoPerformanceTracker.measureStatic("consumeTryToConsumeTime", VideoPerformanceStages.ConsumeTry, VideoPerformanceStages.ConsumeTryEnd, `${srcId}-${kind}`);
        if (consumeTryToConsumeMeasure) {
            globalsMetricsManager.addMetricReliably("avLoadTime", {
                consumeTryToConsumeTime: consumeTryToConsumeMeasure.duration,
            });
        }
        videoPerformanceTracker.mark(VideoPerformanceStages.ConsumeStart, srcId, kind);
    }
    getTransport(direction) {
        return direction === "send" ? this.sendTransport : this.recvTransport;
    }
    async getSFUPlayerData() {
        try {
            return await this.signaling?.sendWithResponse("get-player-data");
        }
        catch (e) {
            Logger.warn(`get-player-data failed: ${e}`);
            return undefined;
        }
    }
    async produceMigrationStart() {
        this.signaling?.emit("produce-migrate");
    }
    async produceMigrationCompleted() {
        this.signaling?.emit("produce-migrate-completed");
    }
    async getConnectionReport(userId) {
        const consumerReport = {};
        const signalingReport = this.signaling?.getConnectionReport() ?? {};
        const recvReport = (await this.recvTransport?.getConnectionReport()) ?? {};
        const consumers = this.consumers.get(userId) ?? new Map();
        for (const [kind, consumer] of consumers.entries()) {
            const prefix = `consumer.${kind}`;
            const report = {
                id: consumer.id,
                paused: consumer.paused,
                closed: consumer.closed,
                producerId: consumer.producerId,
            };
            Object.assign(consumerReport, prefixKeys(prefix, report));
        }
        const subscribed = this.subscribed[userId] ?? new Set();
        return {
            subscribedKinds: [...subscribed].join(" "),
            actuallySubscribed: this.actuallySubscribed[userId] ?? false,
            started: this.finishedInitialStart,
            ...consumerReport,
            ...prefixKeys("signaling", signalingReport),
            ...prefixKeys("transport", recvReport),
        };
    }
    async summarize() {
        const subscribed = {};
        Object.entries(this.subscribed).forEach(([id, tags]) => {
            subscribed[id] = Array.from(tags);
        });
        const tracks = {};
        this.tracks.forEach((track, tag) => {
            tracks[tag] = track ? summarizeMediaStreamTrack(track) : undefined;
        });
        const producers = {};
        this.producers.forEach((producer, tag) => {
            producers[tag] = producer ? { id: producer.id, closed: producer.closed } : undefined;
        });
        const consumers = {};
        this.consumers.forEach((tagToConsumer, id) => {
            const idConsumers = {};
            tagToConsumer.forEach((consumer, tag) => {
                idConsumers[tag] = consumer
                    ? { id: consumer.id, producerId: consumer.producerId, closed: consumer.closed }
                    : undefined;
            });
            consumers[id] = idConsumers;
        });
        const info = {};
        Object.entries(this.info).forEach(([id, idInfo]) => {
            info[id] = idInfo ? idInfo.summarize() : undefined;
        });
        return {
            sfuConnection: this.signaling ? this.signaling._summarize() : undefined,
            reloading: this.reloading,
            reloadingLock: this.reloadingLock,
            subscribed,
            actuallySubscribed: Object.keys(this.actuallySubscribed),
            allowed: Array.from(this.allowed),
            tracks,
            recvTransport: await this.recvTransport?.summarize(),
            sendTransport: await this.sendTransport?.summarize(),
            producers,
            consumers,
            info,
        };
    }
}
//# sourceMappingURL=SFUClient.js.map